
import { HotGlobalConfig } from "@handsontable/angular-wrapper";
import { environment } from "~environments/environment";

export const globalHotConfig: HotGlobalConfig = {
    license: environment.handsontableKey,
    themeName: "ht-theme-main"
};
